import datacentral from '@/utils/axios/datacentral'
import qs from 'query-string'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { ResponseArray, ResponseObject } from '@/types/shared'
import { Employee } from '@/modules/Employee/types/response'
import { SessionsResponse } from '@/modules/Account/types/response'

export const getCurrentEmployee = async (): Promise<
    ResponseObject<Employee>
> => {
    const response = await datacentral.get('/employees/current')
    return response.data
}

export const updateCurrentEmployee = async (
    data: Partial<Employee>
): Promise<ResponseObject<Employee>> => {
    const response = await datacentral.put('/employees/current', data)
    return response.data
}

export const getEmployeeSessions = async (): Promise<
    ResponseObject<SessionsResponse>
> => {
    const response = await datacentral.get('/employees/sessions')
    return response.data
}

export interface EmployeeReferralLink {
    referral_code: string
    referral_link: string
}

export const getCurrentEmployeeReferralLink = async (): Promise<
    ResponseObject<EmployeeReferralLink>
> => {
    const response = await datacentral.get('/employees/current/referral-link')
    return response.data
}

export interface EmployeeReferralSummary {
    referral_code: string
    referral_link: string
    total_clicks: number
    total_conversions: number
    referred_customers: number
    conversion_rate: number
    confirmed_commission: number
    pending_commission: number
    earns_commission: boolean
}

export interface ReferralCustomer {
    customer_id: number
    customer_name: string
    customer_email: string
    company_name?: string
}

export const getCurrentEmployeeReferralStats = async (): Promise<
    ResponseObject<EmployeeReferralSummary>
> => {
    const response = await datacentral.get('/employees/current/referral-stats')
    return response.data
}

export const getCurrentEmployeeReferralCustomers = async (
    payload: DataGridPayload
): Promise<ResponseArray<ReferralCustomer>> => {
    const response = await datacentral.get<ResponseArray<ReferralCustomer>>(
        `/employees/current/referral-customers?${qs.stringify(payload)}`
    )
    return response.data
}
